import { axiosTranont } from "../api/axiosTranont";

export const getItemTranontService = async (data: any, shopSiteName: any) => {
    return await axiosTranont.get('/products', {
        params: {
            ...data,
            locale: data.locale?.replace(/_/g, '-'),
            nfr: shopSiteName === 'nfr' ? true : false,
        }
    })
}

export const getItemDetailServiceTranont = async (ids: String, isNfrProduct: boolean, locale: String, companyName: String) => {
    let url = `/products/${ids}?companyName=${companyName}`;
    const params = new URLSearchParams();
    
    if (isNfrProduct) {
        params.append('nfr', 'true');
    } else {
        params.append('nfr', 'false');
    }
    
    if (locale) {
        params.append('locale', locale.toString().replace(/_/g, '-'));
    }
    
    const queryString = params.toString();
    return await axiosTranont.get(`${url}${queryString ? `&${queryString}` : ''}`);
}

export const postCheckout = async (data: any) => {
    return await axiosTranont.post('cart-universal/v2/carts?api_key=c305557df29a4bb2b487ee6fefc35425',data)
} 